import styled from 'styled-components';
import {constants} from '../../constants';


/*

Props:
• 

*/
export const StyledToolbarContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	max-width: ${constants.layout.contentWidth.maxWidth - 20 + 'px'};
	width: ${constants.layout.contentWidth.width};


`;


// WEBPACK FOOTER //
// ./src/js/components/ToolbarSearch/StyledToolbarContainer.jsx